<mat-card >
    <mat-card-header class="titreFrm">
    <mat-card-title>{{titre}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
         
        <mat-card>
            <mat-card-content>
                <!-------------------- bouton -->
               
                <div class="btn">
                    <div [ngClass]="fenetre != '1' ? 'form' : 'form2'">
                        <mat-form-field     appearance="outline"  >
                            <mat-label>Groupe</mat-label>
                            <mat-select name="evaluation_Groupe" #evaluation_Groupe="ngModel" 
                                [(ngModel)]="appreciation.evaluation_Groupe" placeholder="Groupe" required>
                                <mat-option *ngFor="let Groupe of listeGroupe" [value]="Groupe.value">
                                    {{Groupe.text}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field     appearance="outline" >
                            <mat-label>Cursus</mat-label>
                            <mat-select ame="Cursus_Code" (selectionChange)="onCursusChange($event.value)"
                                placeholder="Cursus">
                                <mat-option *ngFor="let cursus of listeCursus" [value]="cursus.Cursus_Code">
                                    {{cursus.Cursus_Titre}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field     appearance="outline" >
                            <mat-label>Matière</mat-label>
                            <mat-select name="evaluation_matiere" #evaluation_matiere="ngModel" 
                                [(ngModel)]="appreciation.evaluation_matiere" placeholder="Matière" required>
                                <mat-option *ngFor="let matiere of listeMatiereCursus" [value]="matiere.Matiere_Code">
                                    {{matiere.Matiere_Nom}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    
                        <mat-form-field     appearance="outline"  class="width-120">
                            <mat-label>Période</mat-label>
                            <mat-select name="evaluation_periode" #evaluation_periode="ngModel" 
                                [(ngModel)]="appreciation.evaluation_periode" placeholder="Période" required>
                                <mat-option *ngFor="let periode of listePeriode" [value]="periode.value">
                                    {{periode.text}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field     appearance="outline"  class="width-100">
                            <mat-label>Année scolaire</mat-label>
                            <input matInput name="evaluation_anneeScolaire" #evaluation_anneeScolaire="ngModel" [(ngModel)]="appreciation.evaluation_anneeScolaire"  placeholder="Année scolaire" required>
                        </mat-form-field>
                    </div>
                    <div>
                        <button [disabled]="buttonDisabled"  (click)="imprimer()" mat-raised-button class="colorGreen"><mat-icon>print</mat-icon>Imprimer</button>
                        <button [disabled]="buttonDisabled" *ngIf="fenetre != '1'" (click)="openDetailAppreciation(frmDetailAppreciation)" mat-raised-button class="colorGreen"><mat-icon>search</mat-icon>Détail</button>
                        <button [disabled]="buttonDisabled" *ngIf="fenetre == '3'" (click)="detail()" mat-raised-button class="colorGreen"><mat-icon>list</mat-icon>Bulletin de note</button>
                        <button [disabled]="buttonDisabled" *ngIf="fenetre == '3'" (click)="detail()" mat-raised-button class="colorGreen"><mat-icon>list</mat-icon>Relevé de note</button>
                        <button [disabled]="buttonDisabled"  (click)="enregister()" mat-raised-button class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
                    </div>
                </div>
                <app-avt-listes #listeAppreciationComponen [heightTable]="'400'" [dataSourceBrut]="dataSourceAppreciation" [displayedColumnsBrut]="columnsAppreciation"  (btnTable)="clickBtnHeat($event)"></app-avt-listes>
            </mat-card-content>
        </mat-card>    
    </mat-card-content>
</mat-card>
<ng-template #frmDetailAppreciation>
    <mat-card >
        <mat-card-header class="titreFrm">
        <mat-card-title>Informations Apprenant</mat-card-title>
        </mat-card-header>
        <mat-card-content class="border">
            <br>
            <div class="displayFlex">
                <div class="image-apprenant">
                    <img [src]="imageAprenant">
                </div>
                <div class="detail-apprenant">
                    <mat-form-field     appearance="outline"  class="width-100">
                        <mat-label>Date création</mat-label>
                        <input matInput name="dateCreation" disabled="true" placeholder="Date création" [ngModel]="dateCreation" [matDatepicker]="picker2">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field     appearance="outline"  class="width-100">
                        <mat-label>Apprenant</mat-label>
                        <input matInput name="apprenantName" disabled="true" [ngModel]="apprenant"  placeholder="Apprenant">
                    </mat-form-field>
                    
                </div>
                <div>
                    <mat-form-field     appearance="outline"  class="width-100">
                        <mat-label>Groupe</mat-label>
                        <input matInput name="groupeName" disabled="true" [ngModel]="groupe"  placeholder="Groupe">
                    </mat-form-field>
                    <mat-form-field     appearance="outline"  class="width-100">
                        <mat-label>Année scolaire</mat-label>
                        <input matInput name="Annee_Scolaire" disabled="true" [ngModel]="AnneeScolaire"  placeholder="Année scolaire">
                    </mat-form-field>
                    <mat-form-field     appearance="outline"  class="width-120">
                        <mat-label>Période</mat-label>
                        <mat-select name="periode1" disabled="true" [ngModel]="periode" placeholder="Période">
                            <mat-option *ngFor="let periode of listePeriode" [value]="periode.value">
                                {{periode.text}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button [disabled]="buttonDisabled"  (click)="imprimer()" mat-raised-button class="colorGreen"><mat-icon>cloud_download</mat-icon>Télécharger</button>
                </div>
            </div>
            <app-avt-listes #listeDetailAppreciationComponen [heightTable]="'400'" [dataSourceBrut]="" [displayedColumnsBrut]="columnsDetailAppreciation"></app-avt-listes>
        </mat-card-content>
    </mat-card>
</ng-template>